export enum UploadType {
  File = 'Upload File',
}
